// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__TkX4r","head":"Table_head__1LYET","col":"Table_col__11Crm"};